// extracted by mini-css-extract-plugin
export default {"AboutSystem":"about-system_AboutSystem__NGFMP"};